import { GET_BLOG, GET_BLOGS, rtkApi } from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import {
  IBlogArticle,
  IBlogIndexResponse,
  IBlogsRequest,
  IBlogsResponse,
} from './types';

const emptyPagination = {
  page: 1,
  pageSize: 0,
  pageCount: 0,
  total: 0,
};

const blogApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getBlogs: build.query<IBlogsResponse, IBlogsRequest | void>({
      query: (params) => ({
        url: '/blogs',
        params: {
          page: params?.page,
          pageSize: params?.pageSize,
          ...(params?.categoryId !== undefined ? { categoryId: params.categoryId } : {}),
          ...(params?.search ? { search: params.search } : {}),
        },
      }),
      transformResponse: (response: SuccessApiResponse<IBlogsResponse>) =>
        response.data ?? { articles: [], pagination: emptyPagination },
      providesTags: [GET_BLOGS],
    }),
    getAllBlogs: build.query<IBlogIndexResponse, void>({
      query: () => '/blogs/all',
      transformResponse: (response: SuccessApiResponse<IBlogIndexResponse>) =>
        response.data ?? { articles: [] },
      providesTags: [GET_BLOGS],
    }),
    getBlogBySlug: build.query<IBlogArticle | null, string>({
      query: (slug) => `/blogs/${encodeURIComponent(slug)}`,
      transformResponse: (response: SuccessApiResponse<{ article: IBlogArticle }>) =>
        response.data?.article ?? null,
      providesTags: (_result, _error, slug) => [{ type: GET_BLOG, id: slug }],
    }),
  }),
});

export const { useGetBlogsQuery, useGetAllBlogsQuery, useGetBlogBySlugQuery } = blogApi;
